import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Signature from './components/Signature';
export default function extendCommentPost() {
  extend(CommentPost.prototype, 'content', function (content) {
    var _this$attrs$post$user, _this$attrs$post;
    if (this.attrs.post.isHidden() && !this.revealContent) return;
    if ((_this$attrs$post$user = (_this$attrs$post = this.attrs.post).user) != null && _this$attrs$post$user.call(_this$attrs$post)) {
      if (this.attrs.post.user().signature()) {
        const allowInlineEditing = app.forum.attribute('allowInlineEditing') || false;
        content.push(m("div", {
          className: "Post-signature"
        }, m(Signature, {
          user: this.attrs.post.user(),
          readonly: !allowInlineEditing
        })));
      }
    }
  });
}